import React from 'react';

export default function UserProfileImage({ imgUrl, className }) {
    return <img className={`${className}`} src={`${process.env.PUBLIC_URL} ${imgUrl || '/img/single_user.png'}`} alt='Profile Img' />;
}
